module.exports = __webpack_public_path__ + "img/icon-basis-ic-pen.50a9ebb8.svg";